import CustomRadio from 'components/CustomRadio/CustomRadio';
import { BodyMBold, BodyS, HeadingS } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/views/prepaidLoyalty/servicesTabStyle';
import classNames from 'classnames';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ISingleItemProps {
	isSelected: boolean;
	priceOffer: number;
	shortDescription: string;
	name: string;
	handleSelected: () => void;
}

const SingleItem = ({ isSelected, priceOffer, name, shortDescription, handleSelected }: ISingleItemProps) => {
	const classes = useStyles();

	return (
		<div
			className={classNames(classes.singleItem, { [classes.selectedSingleItem]: isSelected })}
			onClick={handleSelected}
		>
			<div className={classes.radioDescContainer}>
				<CustomRadio checked={isSelected} onChange={() => {}} />
				<div className={classes.radioLabel}>
					<HeadingS disableMargin inline>
						{name}
					</HeadingS>
				</div>
				<div className={classes.shortDescription}>
					<BodyS disableMargin inline>
						{shortDescription}
					</BodyS>
				</div>
			</div>
			<div className={classes.priceContainer}>
				<BodyMBold disableMargin inline>
					{translate('price', priceOffer)}
				</BodyMBold>
			</div>
		</div>
	);
};

export default SingleItem;
